import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wraps every /portal/* route. Two responsibilities:
//   • If nobody is signed in, bounce to /login.
//   • If the signed-in account is NOT a parent (a staff user wandered
//     in), bounce them to /dashboard. The portal is parent-only.
export default function ParentGuard({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'parent') return <Navigate to="/dashboard" replace />;
  return children;
}
